
    import { cloudinaryUrl } from './cloudinary.js'
    import { initIris } from './iris.js'
    initIris()

    fetch('/data/shop.json')
      .then(r => r.json())
      .then(products => {
        const grid = document.getElementById('shopGrid')
        if (!products.length) {
          grid.innerHTML = '<p class="gallery-empty">Products coming soon.</p>'
          return
        }
        grid.innerHTML = products.map(p => `
          <div class="shop-card">
            ${p.image
              ? `<div class="shop-card-img-wrap"><img src="${cloudinaryUrl(p.image, 'w_800,q_auto,f_auto')}" alt="${p.title}" loading="lazy"></div>`
              : `<div class="shop-card-img-wrap shop-card-img-wrap--empty"></div>`
            }
            <div class="shop-card-body">
              <h3 class="shop-card-title">${p.title}</h3>
              <p class="shop-card-desc">${p.description}</p>
              <p class="shop-card-size">${p.size}</p>
              <div class="shop-card-footer">
                <span class="shop-card-price">${p.price}</span>
                <button class="panel-cta shop-buy-btn" data-price-id="${p.priceId}" aria-label="Buy ${p.title}">Buy print</button>
              </div>
            </div>
          </div>
        `).join('')

        grid.querySelectorAll('.shop-buy-btn').forEach(btn => {
          btn.addEventListener('click', async () => {
            const priceId = btn.dataset.priceId
            btn.textContent = 'Loading…'
            btn.disabled = true
            try {
              const res = await fetch('/api/create-checkout', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ priceId }),
              })
              const data = await res.json()
              if (data.url) {
                window.location.href = data.url
              } else {
                throw new Error(data.error || 'Unknown error')
              }
            } catch (err) {
              console.error('Checkout error:', err)
              btn.textContent = 'Try again'
              btn.disabled = false
            }
          })
        })
      })
      .catch(() => {})

    // Order status message after Stripe redirects back (?order=success|cancelled)
    ;(function () {
      const params = new URLSearchParams(window.location.search)
      const order  = params.get('order')
      if (!order) return
      window.history.replaceState({}, '', window.location.pathname)
      const msgEl = document.getElementById('shopOrderMsg')
      if (order === 'success') {
        msgEl.textContent = '✓ Order placed — thank you! You\'ll receive a confirmation email shortly.'
        msgEl.className   = 'shop-order-msg shop-order-msg--success'
      } else if (order === 'cancelled') {
        msgEl.textContent = 'Payment cancelled — your order was not placed.'
        msgEl.className   = 'shop-order-msg shop-order-msg--cancelled'
      }
    })()

    document.addEventListener('contextmenu', e => { if (e.target.tagName === 'IMG') e.preventDefault() })
    document.addEventListener('dragstart', e => { if (e.target.tagName === 'IMG') e.preventDefault() })

    const navToggle   = document.querySelector('.nav-toggle')
    const mobileNav   = document.getElementById('mobileNav')
    const mobileClose = document.querySelector('.mobile-nav-close')
    navToggle.addEventListener('click', () => mobileNav.classList.add('open'))
    mobileClose.addEventListener('click', () => mobileNav.classList.remove('open'))
    document.querySelectorAll('.mobile-nav-link').forEach(l => l.addEventListener('click', () => mobileNav.classList.remove('open')))
  